import React from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import { makeStyles } from '@paintscout/ui'
import CRMPromptPage from 'src/components/layouts/CRMPromptPage'
import TaskList from '../../common/TaskTable/TaskList'
import { TasksShim } from './TasksShim'

const useStyles = makeStyles(() => ({
  section: {
    marginTop: 3
  }
}))

export default function Tasks() {
  const classes = useStyles()
  const { crm: crmFlag } = useFlags()

  return (
    <BasePage>
      <DocumentTitle title="Tasks" />

      {crmFlag ? (
        <div className={classes.section}>
          <TaskList />
        </div>
      ) : (
        <CRMPromptPage Background={<TasksShim />} />
      )}
    </BasePage>
  )
}
